import { createFileRoute, redirect } from '@tanstack/react-router';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { env } from '@/constants/env';
import { ensureEstateQueryData } from '@/features/estates-property/api/estate';
import { requireGeneralRead } from '@/features/permissions/route-permissions';
import { parseStringToBool } from '@/utils/parseStringToBool';
import { EstateAnalyticsDashboard } from '@/pages/estates-analytics';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/analytics'
)({
  component: EstateAnalyticsDashboard,
  loader: async (args) => {
    const estate = await ensureEstateQueryData(args);

    requireGeneralRead(estate.metadata?.permissions);

    if (!parseStringToBool(env.SHOW_PRICEHUBBLE)) {
      throw redirect({
        to: '/estates/$estateId',
        params: {
          estateId: args.params.estateId,
        },
      });
    }

    return estate;
  },
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="estate-analytics" /> },
});
